type ParserFunction = (text: string) => [string, string]

const fixedSizeParser = (length: number): ParserFunction => (text: string) => [text.slice(0, length), text.slice(length)]
const dateParser: ParserFunction = fixedSizeParser(6)

const terminationParser = (text: string, iter: number = 0, result: string = ''): [string, string] =>
    text.charAt(iter) === '\u001d' || text.length === iter
        ? [result + (text.charAt(iter) === '\u001d' ? '' : text.charAt(iter)), text.slice(iter + 1)]
        : terminationParser(text, iter + 1, result + text.charAt(iter))

const exec = (code: string, func: ParserFunction, text: string, acc: Record<string, string>) => {
    const [data, remainder] = func(text.slice(code.length))
    return decode(remainder, { ...acc, [code]: data })
}

const decode = (remainder: string, accumulator: Record<string, string> = {}): Record<string, string> => {
    if (!remainder.length) return accumulator
    if (remainder.charAt(0) === '\u001d') return decode(remainder.slice(1), accumulator)

    const code = remainder.slice(0, 2)

    switch (code) {
        case '01': return exec(code, fixedSizeParser(14), remainder, accumulator)
        case '10': return exec(code, terminationParser, remainder, accumulator)
        case '11': return exec(code, dateParser, remainder, accumulator)
        case '17': return exec(code, dateParser, remainder, accumulator)
        case '24': return exec('240', terminationParser, remainder, accumulator)
        case '91': return exec(code, terminationParser, remainder, accumulator)
        default: throw new Error(`Unknown code: ${code}`)
    }
}

export default decode
